import React, { useEffect, useState } from "react";
import { Field, reduxForm } from "redux-form";
import { required } from "redux-form-validators";
import { useDispatch } from "react-redux";
import SelectBox from "../../../../../Components/Forms/selectbox";
import { fetchkampeerplaatsenverplaatsen } from "../../../Reducers/actions";

const VerplaatsenBoeking = ({ handleSubmit }) => {
  const [plaatsen, setPlaatsen] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch(); // ← nodig voor Redux thunk

  useEffect(() => {
    async function fetchData() {
      const data = await dispatch(fetchkampeerplaatsenverplaatsen()); // dispatch de thunk
      const vrijePlaatsen = data.filter(
        (plaats) => !plaats?.sensor?.boeking?._id
      );
      setPlaatsen(vrijePlaatsen);
      setLoading(false);
    }

    fetchData();
  }, [dispatch]);

  if (loading) return <div>Bezig met laden...</div>;

  return (
    <form onSubmit={handleSubmit} className="kwh-settings p-2 mt-4">
      <h4 className="m-0">Reservering Verplaatsen</h4>

      <Field
        name="plaats"
        component={SelectBox}
        options={plaatsen}
        inputnaam="naam"
        inputvalue="_id"
        type="input"
        label="Kies een plaats"
        validate={[required()]}
      />

      <div className="box-footer">
        <button type="submit" className="btn btn-primary">
          Verzenden
        </button>
      </div>
    </form>
  );
};

export default reduxForm({
  form: "verplaatsboekingform",
})(VerplaatsenBoeking);